import React, { useEffect, Fragment } from 'react';
import { useLocation } from "react-router-dom";
import { scroller } from 'react-scroll'

export default function ScrollToTop({ children }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {

    if (hash) {
      const target = document.getElementById(hash.replace('#', ''));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }

    scroller.scrollTo('root', {
      duration: 200,
      delay: 100,
      smooth: 'easeInOutQuart',
    })

  }, [pathname, hash]);

  return <Fragment>{children}</Fragment>;
}
